import "./../assets/scss/pageheader.scss";
import { BackIcon, InvoiceBackIcon, PageHeaderListIcon } from "./Icons";
import photoUrl from "./../assets/images/profile.png";
import { Link, useNavigate, useSearchParams } from "react-router-dom";
import { Image } from "react-bootstrap";
import ChevronDownIcon from "mdi-react/ChevronDownIcon";
import { useAuth } from "../hooks/useAuth";
import { useQuery } from "react-query";
import { customerFullName, fetchActionsUtil } from "../utils/helpers";

export default function InvoicePageHeader({
  name = "...",
  description = "...",
  icon = <PageHeaderListIcon />,
  DescriptionComponent,
  NonShowBack,
}) {
  let navigate = useNavigate();
  const { backendUrl } = useAuth();

  const [searchParams] = useSearchParams();
  const customerId = searchParams.get("customerId");

  const { data } = useQuery([customerId], () =>
    fetchActionsUtil(
      `${backendUrl}/api/customers/single?customerId=${customerId}`
    )
  );

  return (
    <div className="page-header d-flex justify-content-between align-items-center px-3 py-4 bg-white">
      <div className="title-area d-flex align-items-center">
        {!NonShowBack && (
          <button onClick={() => navigate(-1)} className="btn back-btn">
            <div className="invoice-icon text-primary">
              {" "}
              <InvoiceBackIcon />
            </div>
          </button>
        )}

        <div className="d-flex align-items-center">
          <div className="icon text-primary">{icon}</div>
          <div>
            {customerId && data?.data && (
              <h2>{customerFullName(data?.data)}</h2>
            )}
            <h2>{name}</h2>
            <p>{description}</p>
            {DescriptionComponent ? DescriptionComponent : null}
          </div>
        </div>
      </div>

      {/* <div>
        <button className="btn user-profile">
          <div className="avatar">
            <Image src={photoUrl} />
          </div>
          <div className="user-info me-1">
            <span>Admin 01</span>
            <span>admin_username</span>
          </div>

          <ChevronDownIcon />
        </button>
  </div> */}
    </div>
  );
}
